<template>
  <el-dialog
    top="10vh"
    class="menu-manage-dialog"
    :title="id ? '编辑' : '新建'"
    width="560px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" size="small">
        <el-form-item label="菜单名称:" prop="name">
          <el-input
            style="width: 340px;"
            v-model.trim="form.name"
            placeholder="菜单名称"
            :maxlength="40"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="请求地址:" prop="url">
          <el-input
            style="width: 340px;"
            type="textarea"
            resize="none"
            :rows="3"
            v-model.trim="form.url"
            placeholder="如果为主菜单则填写#"
            :maxlength="255"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="排序:" prop="sortNum">
          <el-input
            style="width: 340px;"
            v-model.trim="form.sortNum"
            placeholder="排序号"
            :maxlength="40"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="state">
          <el-switch
            active-value="Y"
            inactive-value="N"
            v-model="form.state"
            active-text="启用"
            inactive-text="禁用"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否为操作按钮:" prop="isOperation">
          <el-switch
            v-model="form.isOperation"
            active-value="Y"
            inactive-value="N"
            active-text="是"
            inactive-text="否"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否为主菜单" prop="isMainMenu">
          <el-switch
            v-model="form.isMainMenu"
            active-value="Y"
            inactive-value="N"
            active-text="是"
            inactive-text="否"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="操作类型:" prop="operationCode">
          <Select
            style="width: 340px;"
            filterable
            allow-create
            query="web/menu/operation/code"
            v-model="form.operationCode"
            placeholder="操作类型"
          >
          </Select>
        </el-form-item>
        <el-form-item label="icon:" prop="icon">
          <el-input
            style="width: 340px;"
            v-model.trim="form.icon"
            placeholder="icon"
            :maxlength="40"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="父级菜单:" prop="pid">
          <MenuCascader
            style="width: 340px;"
            :disabled="!form.id && type == 'sub'"
            :query="$api.system.menu_tree"
            v-model="form.pid"
            placeholder="父级菜单"
          >
          </MenuCascader>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="menu-manage-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
import MenuCascader from './MenuCascader'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pids: {
      type: [String, Array]
    },
    id: String,
    type: String
  },
  components: {
    Select,
    MenuCascader
  },
  data() {
    let validatename = (rule, value, callback) => {
      if (!this.form.name) {
        callback(new Error('请输入菜单名称'))
      } else {
        callback()
      }
    }
    let validateurl = (rule, value, callback) => {
      if (!this.form.url) {
        callback(new Error('请输入请求地址'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: this.visible,
      form: {
        id: '',
        name: '',
        state: 'Y',
        sortNum: '',
        operationCode: '',
        isOperation: 'N',
        isMainMenu: 'N',
        url: '',
        pid: this.pids || '',
        icon: ''
      },
      rules: {
        name: [{ validator: validatename, trigger: 'blur', required: true }],
        url: [{ validator: validateurl, trigger: 'blur', required: true }]
      }
    }
  },
  created() {
    if (this.id) {
      let params = {
        id: this.id
      }
      this.$ajax.get('web/menu/detail', params).then((res) => {
        for (const key in this.form) {
          this.form[key] = res.data[key]
        }
      })
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      let params = {
        ...this.form
      }
      let api = this.form.id ? this.$api.system.menu_update : this.$api.system.menu_add
      this.$ajax.post(api, params).then(() => {
        this.$message.success(`${this.form.id ? '编辑成功' : '新建成功'}`)
        this.close()
        this.$emit('refresh')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.menu-manage-dialog {
  .el-dialog__body {
    padding: 15px 20px;
  }
  .menu-manage-footer {
    text-align: center;
  }
}
</style>
